import { Card, Form, Button, Row, Col } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { useEffect, useState } from "react";
import { GetImpsAction, exportCIMPDataAction } from "../../Redux/Actions/AdsImpressionsActions";
import "./style.css";
import * as yup from "yup"
import {
  useFormik
} from "formik"
import { convertUtcToLocal } from "../../utils/functions";
import Spinner from "../../Components/UI/Spinner/Spinner";
import { CImpColumns } from "./CImpConstant";
import CsvDownloader from "react-csv-downloader";
import HashModal, { HashButton } from "../Admin/HashModal";
import FeatherIcon from "feather-icons-react";


const AdsImpressions = () => {
  const dispatch = useDispatch();
  const AdsImpressionsState = useSelector(
    (state: IReduxState) => state.AdsImpressions
  );
  const adminState = useSelector((state: IReduxState) => state.Auth);


  const [tableData,setTableData] = useState(AdsImpressionsState?.imps);
  const [isFiltered, setIsFiltered] = useState(false);
  const [showHashModal, setShowHashModal] = useState(false);
  const handleCloseModal = () => setShowHashModal(false);

  const filterData = ()=>{
    setTableData(AdsImpressionsState?.imps.filter(function(item:any){
      var ret = true;
      if(js){
        // console.log(item.js_platform+"  "+item.js_model+"  "+ item.js_plarform_version+"  "+item.js_browser_version);
        if((!item.js_platform || item.js_platform==='undefined' ||item.js_platform.trim()==='')&&
        (!item.js_model||item.js_model==='undefined'||item.js_model.trim()==='')&&
        (!item.js_plarform_version || item.js_plarform_version==='undefined'||item.js_plarform_version.trim()==='')&&
        (!item.js_browser_version ||item.js_browser_version==='undefined'||item.js_browser_version.trim()==='')){
          ret=false;
        }
      }
      if(ret == true){
        setIsFiltered(false)
      } else {
        setIsFiltered(true)
      }
      return ret;
    }));
  }

  const [showFilter, setShowFilter] = useState(false);
  const [filterText, setFilterText] = useState("Add Filter");


  const [js,setJs] = useState(false);

  const handleJs = () => {
    setJs(!js)
  }

  let newColumns = CImpColumns.map((column: any) => {
    
    if (column.Header === 'Date') {
      return {
        id: 'date',
        displayName: column.Header,
      };
    }
    
    if (column.Header === 'Time') {
      return {
        id: 'time',
        displayName: column.Header,
      };
    }

    return {
      id: column.accessor,
      displayName: column.Header,
    };
  });

  const CImpDataTable = tableData.map((item: any) => {
    const fixedItem: any = {};
    for (const prop in item) {
      const value = item[prop];
      fixedItem[prop] = value
        ? typeof value === 'string' && value.includes(",")
          ? `"${value}"`
          : value
        : "";
    }
  
    return {
      ...fixedItem,
      'date': convertUtcToLocal(item.timestamp, "DD/MM/YYYY"),
      'time': convertUtcToLocal(item.timestamp, "HH:mm:ss"),

    };
  });

  const formik: any = useFormik({
    initialValues: {
      hour: "30",
      searchBy: 'appwebId',
      search: '',
      // ip: "",
      // type: "",
      // appwebId: "",
      // sha1: "",
      // domain: "",
      csv: false
    },
    validationSchema : yup.object().shape({
      search: yup.string().required("Search is required").when('searchBy', {
        is: 'ip',
        then: yup.string().matches(
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
          "Please use IPv4 address format (X.X.X.X)"
        )
      }),
    }),

    // validationSchema: yup.object().shape({
    //   ip: yup.string()
    //     .ensure().when('appwebId', {
    //       is: "",
    //       then: yup.string()
    //         .ensure().when('domain', {
    //           is: "",
    //           then: yup.string()
    //             .ensure().when('sha1', {
    //               is: "",
    //               then: yup.string().required('Either IP, App/Web ID, Domain or SHA1 is required').matches(
    //                 /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
    //                 "Please use IPv4 address format (X.X.X.X)"
    //               )
    //             }),
    //         }),
    //       //otherwise: yup.string()
    //     }),
    //   appwebId: yup.string().ensure().when('ip', {
    //     is: "",
    //     then: yup.string()
    //       .ensure().when('domain', {
    //         is: "",
    //         then: yup.string()
    //           .ensure().when('sha1', {
    //             is: "",
    //             then: yup.string().required('Either IP, App/Web ID, Domain or SHA1 is required')
    //           }),
    //       }),
    //     // otherwise: yup.string()
    //   }),
    //   sha1: yup.string().ensure().when('ip', {
    //     is: "",
    //     then: yup.string()
    //       .ensure().when('domain', {
    //         is: "",
    //         then: yup.string()
    //           .ensure().when('appwebId', {
    //             is: "",
    //             then: yup.string().required('Either IP, App/Web ID, Domain or SHA1 is required'),
    //             // otherwise: yup.string()
    //           }),
    //       }),
    //     // otherwise: yup.string()
    //   }),
    //   domain: yup.string().ensure().when('ip', {
    //     is: "",
    //     then: yup.string()
    //       .ensure().when('sha1', {
    //         is: "",
    //         then: yup.string()
    //           .ensure().when('appwebId', {
    //             is: "",
    //             then: yup.string().required('Either IP, App/Web ID, Domain or SHA1 is required'),
    //             // otherwise: yup.string()
    //           }),
    //       }),
    //     // otherwise: yup.string()
    //   }),
    // }, [["ip", "appwebId"]]
    //),

    onSubmit: (value, { resetForm }) => {
      if (value.csv) {
        dispatch(exportCIMPDataAction(value.hour, value.searchBy,value.search));
      } else {
        dispatch(GetImpsAction(value.hour, value.searchBy ,value.search));
      }
      value.csv = false;
    },
  });

  useEffect(() => {
    dispatch(GetImpsAction(null, "", ""));
  }, [dispatch]);

  useEffect(() => {
    if(isFiltered==false){
      setTableData(AdsImpressionsState.imps)
    }
  },[AdsImpressionsState])

  

  const sizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
  ];

  return (
    <>
    {showHashModal && <HashModal showHashModal={showHashModal} onClose={handleCloseModal}/>}
      <Row className="d-flex justify-content-center mt-3">
        <Row>
          <h3 className="module_title" style={{marginBottom:'0px'}}>
            Ads Impressions
            <p>Viewing recent Ad impressions for a specific IP or ADID</p>
          </h3>
        </Row>
      </Row>
      <Card>
        <Card.Body>
          <div className="expertFilter">
            <div className="expertFilterFields">
              <div>
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  Time Range:
                </Form.Label>
                <Form.Select
                  name="hour"
                  value={formik.values.hour}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="fsz-875rem "
                >
                  <option value="30">Last 30 Minutes</option>
                  <option value="1">Last Hour</option>
                  <option value="2">Last 2 Hours</option>
                  <option value="3">Last 3 Hours</option>
                  <option value="4">Last 4 Hours</option>
                  <option value="24">Last 24 Hours</option>
                  <option value="48">Last 48 Hours</option>
                </Form.Select>
              </div>
              <div>
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  Search By:
                </Form.Label>
                <Form.Select
                  name="searchBy"
                  value={formik.values.searchBy}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="fsz-875rem "
                >
                  <option value="appwebId">App/Web Id</option>
                  <option value="ip">IP</option>
                  <option value="sha1">SHA1</option>
                  <option value="domain">Domain</option>
                  <option value="bundle">Bundle</option>
                </Form.Select>
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  Search Parameter:

                </Form.Label>

                <Form.Control
                  id="search"
                  type="text"
                  name="search"
                  className="fsz-875rem"
                  value={formik.values.search}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.search}
                />
              </div>
              <div className="btngrp">
                <Button
                  className="noMargin"
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  variant="success"
                >
                  Apply
                </Button>

                <Button
                  onClick={() => {
                    formik.resetForm({
                      values: {
                        hour: "30",
                        type: "",
                        appwebId: "",
                        ip: "",
                        domain:"",
                        search:""
                      },
                    });
                  }}
                  className="noMargin"
                  variant="secondary"
                >
                  Clear
                </Button>
                <Button
                  onClick={() => {
                    setShowFilter(!showFilter);
                    setFilterText(showFilter ? "Add Filter" : "Close Filter");
                    setTableData(AdsImpressionsState.imps);
                  }}
                  className="noMargin"
                  variant="info"
                >
                  {filterText}
                </Button>
              </div>
            </div>
            <div className="expertFilterFields">
              {adminState.show_hash &&
            // <Button
            //                   className="mb-0 mr-2 orange-btn"
            //                   variant="warning"
            //                   onClick={() => {
            //                     setShowHashModal(true);
            //                   }}
            //                 >
            //                   <FeatherIcon icon='hash' size={17} style={{ verticalAlign: 'sub'}}/> User ID{" "}
            //                 </Button>
            <HashButton onClick={() => {setShowHashModal(true)}} className={'mb-0 mr-2 orange-btn'}/>
}
            <CsvDownloader
              datas={CImpDataTable}
              columns={newColumns}
              text="Export to CSV"
              filename={`cimp_` + new Date().toLocaleString()}
              extension=".csv"
              className="btn btn-primary ExportBtn no-margin"
            />
            </div>
          </div>
          <div className="position-relative">
            {formik.errors.search ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors.search}
              </span>
            ) : null}
          </div>
          {showFilter &&
            <Row
            >
              <Form.Group
                as={Row}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <Col xs="auto" style={{ display: "flex" }}>
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  style={{marginBottom: "0"}}
                >
                  Filter
                </Form.Label>
                </Col>
                <Col
                  lg={9}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginLeft: '10px'
                  }}
                >
                  <Col xs="auto" style={{ display: "flex"}}>
                    <Form.Check
                      onChange={(e) => {
                        handleJs();
                      }}
                      checked={js}
                      name="JS"
                      type="checkbox"
                      id="JS"
                    />
                    <Form.Label
                      style={{ margin: "0px 15px 0px 5px" }}
                      id="smallerFontSize"
                    >
                      JS
                    </Form.Label>
                  </Col>
                  <Form.Group
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Button
                  onClick={() => {
                    filterData();

                  }}
                  className="noMargin"
                  variant="primary"
                >
                  APPLY
                </Button>
                    
                  </Form.Group>
                </Col>
              </Form.Group>
            </Row>
          }
          {AdsImpressionsState.loading && (<div className="popUpUser"><Spinner className="m-2" color={"primary"}></Spinner></div>)}
          <Table
            columns={CImpColumns}
            data={tableData}
            pageSize={10}
            sizePerPageList={sizePerPageList}
            isSortable={false}
            pagination={true}
            isSearchable={false}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default AdsImpressions;
